import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const AboutStevenNew = ({ onRegisterClick }) => {
  return (
    <div className="py-16 sm:py-24 bg-[#0A0A0B] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        {/* About Section */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 mb-16 sm:mb-24">
          <div className="w-full lg:flex-1">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F5A623]/20 to-transparent rounded-3xl blur-3xl"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/k0p3ymwm_ChatGPT%20Image%20Mar%2019%2C%202026%2C%2004_51_31%20PM.png"
                alt="Steven Yong - Signature of Wealth Master"
                className="relative w-full h-auto object-contain rounded-3xl shadow-2xl"
              />
            </div>
          </div>

          <div className="w-full lg:flex-1 space-y-4 sm:space-y-6">
            <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase">
              Profile
            </p>
            <h2 className="text-3xl sm:text-5xl font-bold leading-tight">
              Steven Yong
            </h2>
            <p className="text-lg sm:text-2xl text-gray-300 font-semibold">
              Translating Ancient Strategy into Modern Advantage
            </p>
            
            <div className="space-y-4 text-base sm:text-lg text-gray-300 leading-relaxed">
              <p>
                At just 22 years old, Steven Yong made a decision that would forever change his life—he redesigned his own signature. What seemed like a small change at the time turned out to be a powerful shift in energy (Qi) that unlocked a series of life-changing opportunities.
              </p>
              <p>
                After altering his signature, Steven began to experience unexplained strokes of luck, influential mentors (noblemen) entering his life, and a remarkable elevation in his career and personal growth. Doors that once seemed closed suddenly opened, and success flowed effortlessly.
              </p>
              <p>
                Realizing the profound impact a signature holds, Steven dedicated himself to mastering the science behind signature energy, feng shui, and graphology. He studied the strokes, curves, and flow of some of the most successful people in the world.
              </p>
              <p>
                Today, as the creator of the Signature of Wealth program, Steven has helped thousands of individuals—from entrepreneurs to professionals and celebrities—realign their signatures to attract wealth, confidence, and endless opportunities.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button 
                onClick={onRegisterClick}
                className="bg-[#F5A623] hover:bg-[#E59400] text-black font-bold px-6 sm:px-8 py-3 rounded-lg group text-sm sm:text-base"
              >
                CLICK HERE TO REGISTER FOR THE SIGNATURE OF WEALTH WEBINAR
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutStevenNew;